export default __webpack_public_path__ + "static/media/employees_10.abfcde65.png";